import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const carousel = document.querySelector('.block-suspects-carousel__carousel');

  if (carousel) {
    new Swiper(carousel, {
      slidesPerView: 1,
      spaceBetween: 40,
      centerInsufficientSlides: true,

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 80,
        },
      },
      navigation: {
        nextEl: '.block-suspects-carousel__carousel .swiper-button-next',
        prevEl: '.block-suspects-carousel__carousel .swiper-button-prev',
      },
    });
  }
});
